module.exports = __webpack_public_path__ + "static/media/pinterest.8eaee581.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pinterest.jpg
// module id = 44
// module chunks = 0